/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeedbackStateLabels
 */
export interface FeedbackStateLabels {
    /**
     * 
     * @type {string}
     * @memberof FeedbackStateLabels
     */
    requested: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackStateLabels
     */
    received?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackStateLabels
     */
    stale?: string;
}

export function FeedbackStateLabelsFromJSON(json: any): FeedbackStateLabels {
    return FeedbackStateLabelsFromJSONTyped(json, false);
}

export function FeedbackStateLabelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackStateLabels {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'requested': json['requested'],
        'received': !exists(json, 'received') ? undefined : json['received'],
        'stale': !exists(json, 'stale') ? undefined : json['stale'],
    };
}

export function FeedbackStateLabelsToJSON(value?: FeedbackStateLabels | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'requested': value.requested,
        'received': value.received,
        'stale': value.stale,
    };
}

